import React from 'react';
import * as util from "../../../other/util.js";
import FleetStep from "./fleet-step.js";
import FleetFormulas from "../../../share/formulas/fleet-formulas.js";

export class PendingRepairFleetStep extends FleetStep {
    constructor() {
        super("REPAIR");
    }

    render(props, idx) {
        let fleet = props.fleet;
        let repair_time_ms = FleetFormulas.getTimeForRepair(fleet);

        return (
            <div>
                <p className="boring-info-text">Repairing</p>
                <span>
                    <span className="boring-info-text">Time: </span>
                    <util.NiceInlineTimeSpan timeSpan={repair_time_ms} />
                </span>
            </div>);
    }
}

export class FixedRepairFleetStep extends FleetStep {
    render(props, idx) {
        let task = props.task;
        let step = task.steps[idx];

        if (this._isStepDone(props, idx)) {
            return this._renderDone("Repairing", idx);
        }

        let timer = (<util.NiceInlineTimeSpan timeSpan={step.duration} />);
        if (this.isStepActive(props, idx)) {
            timer = (<util.Timer date={step.finished} style={{ display: "inline" }} />);
        }

        return (
            <div>
                <p className="boring-info-text">Repairing</p>
                <span>
                    <span className="boring-info-text">Time: </span>
                    {timer}
                </span>
            </div>);
    }
}